// extracted by mini-css-extract-plugin
export default {"container":"dp-z","brandName":"ep-z","productName":"fp-z","aboveGalleryInfo":"gp-z","belowGalleryInfo":"hp-z","breakLongProductName":"ip-z"};